<template>
  <div>
    <h1 class="page-header">{{ $t('user.pageTitle') }}</h1>
    <div>
      <ts-card>
        <ts-card-wrapper>
          <div class="d-flex justify-content-between">
            <ts-button color="info" outline @click="showForm()">{{ $t('addNew') }}</ts-button>
            <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px;" />
          </div>
        </ts-card-wrapper>
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'company.company_name_en'
          }"
        >
          <template v-slot="{ record }">
            <td></td>
            <td>{{ record.user_name }}</td>
            <td>{{ record.full_name }}</td>
            <td>{{ record.roles.map(r => r.name).join(', ') }}</td>
            <td class="text-center">
              <i class="fas fa-check ts-text-green-500" v-show="record.disable"></i>
              <i class="fas fa-times ts-text-red-500" v-show="!record.disable"></i>
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              <a href="#" v-tooltip="$t('tooltip.edit')" class="text-primary mr-2" @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('user.changePassword')"
                class="text-primary mr-2"
                @click.prevent="openChangePasswordDialog(record)"
              >
                <i class="fas fa-key"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('tooltip.delete')"
                class="text-danger"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
        <div class="d-flex justify-content-end p-15">
          <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
        </div>
      </ts-card>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './form.vue'
import ResetPasswordForm from './reset-password.vue'

export default {
  name: 'user',
  components: { FormComponent, ResetPasswordForm },
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('security/user', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.security.user.search
      },
      set(newValue) {
        this.$store.commit('security/user/SET_SEARCH', newValue)
        this.$store.commit('security/user/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: '',
          class: 'ts-w-10'
        },
        {
          name: this.$t('user.userName'),
          sortKey: 'user_name'
        },
        {
          name: this.$t('user.fullName'),
          sortKey: 'full_name'
        },
        {
          name: this.$t('user.role')
        },
        {
          name: this.$t('user.disable'),
          sortKey: 'disable',
          style: 'text-align:center; width: 1px;'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px; white-space: nowrap;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('security/user/fetch', { include: 'roles,company,branches', ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.showForm(record)
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('security/user/destroy', record.user_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '800px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    openChangePasswordDialog(user) {
      this.$modal.show(
        ResetPasswordForm,
        {
          user
        },
        {
          height: 'auto',
          width: '400px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
